
import * as utils from "./utils";

export function costToForm(rate) {
    let cleanedCost = Object.assign({}, rate);

    if (utils.notNullNorUndefined(cleanedCost.company) && cleanedCost.company.id !== undefined) {
        cleanedCost.company = cleanedCost.company.id;
    }

    /*if (utils.notNullNorUndefined(cleanedCost.currency) && cleanedCost.currency.id !== undefined) {
        cleanedCost.currency = cleanedCost.currency.id;
    }*/

    cleanedCost.invoiceFile = cleanedCost.url;

    return cleanedCost;
}


// WEBPACK FOOTER //
// ./src/utils/cost.js